import { UserLayout, TabLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'

/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [

  {
    path: '/',
    name: 'dashboard',
    component: TabLayout,
    meta: { title: '首页' },
    redirect: '/dashboard/analysis',
    children: [

    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      }
    ]
  },
  {
    path: '/dashboard',
    component: TabLayout,
    redirect: '/dashboard/analysis',
    children: [
      {
        path: 'analysis',
        name: 'analysis',
        meta: { title: '首页' },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Analysis')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  // 会员收银台独立全屏窗口（不套 TabLayout，复用 CashierDesk；走正常登录校验，不进白名单）
  {
    path: '/pos',
    name: 'PosCashier',
    hidden: true,
    meta: { title: '零售收银' },
    component: () => import(/* webpackChunkName: "member-cashier" */ '@/views/plugin/member/cashier/CashierDesk')
  },
  // 会员收银台顾客副屏（主屏 window.open 打开的独立展示页，免登录见 permission.js 白名单）
  {
    path: '/cashier/customer-screen',
    name: 'CashierCustomerScreen',
    hidden: true,
    meta: { title: '顾客副屏' },
    component: () => import(/* webpackChunkName: "member-cashier" */ '@/views/plugin/member/cashier/CustomerScreen')
  },
  // ============ 独立收银端（dining-plugin，全屏不套框架壳，登录页免登录见 permission.js）============
  {
    path: '/cashier/login',
    name: 'CashierLogin',
    hidden: true,
    meta: { title: '收银台登录' },
    component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/Login')
  },
  {
    path: '/cashier/choose',
    name: 'CashierChoose',
    hidden: true,
    meta: { title: '选择工作台' },
    component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/Choose')
  },
  {
    path: '/cashier/retail',
    name: 'CashierRetail',
    hidden: true,
    meta: { title: '零售收银' },
    component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/RetailShell')
  },
  {
    path: '/cashier/dining',
    name: 'CashierDining',
    hidden: true,
    meta: { title: '餐饮收银' },
    redirect: '/cashier/dining/table',
    component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/CashierLayout'),
    children: [
      {
        path: 'fastfood',
        name: 'CashierDiningFastfood',
        hidden: true,
        meta: { title: '收银' },
        component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/FastfoodView')
      },
      {
        path: 'table',
        name: 'CashierDiningTable',
        hidden: true,
        meta: { title: '堂食' },
        component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/TableView')
      },
      {
        path: 'order',
        name: 'CashierDiningOrderView',
        hidden: true,
        meta: { title: '订单' },
        component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/OrderView')
      }
    ]
  },
  {
    path: '/cashier/dining/order/:tableId',
    name: 'CashierDiningOrder',
    hidden: true,
    meta: { title: '餐饮点餐' },
    component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/OrderPanel')
  },
  {
    path: '/cashier/dining/settle/:orderId',
    name: 'CashierDiningSettle',
    hidden: true,
    meta: { title: '餐饮结算' },
    component: () => import(/* webpackChunkName: "dining-cashier" */ '@/views/plugin/dining/cashier/Settle')
  },
  // 收单插件 H5 客户端（移动端，免登录走自身微信授权，见 permission.js 白名单 /h5）
  {
    path: '/h5/login',
    name: 'H5Login',
    hidden: true,
    meta: { title: 'H5登录' },
    component: () => import(/* webpackChunkName: "order-receive-h5" */ '@/views/plugin/order-receive/h5/H5Login')
  },
  {
    path: '/h5/partners',
    name: 'H5Partners',
    hidden: true,
    meta: { title: 'H5伙伴' },
    component: () => import(/* webpackChunkName: "order-receive-h5" */ '@/views/plugin/order-receive/h5/H5Partners')
  },
  {
    path: '/h5/orders',
    name: 'H5Orders',
    hidden: true,
    meta: { title: 'H5订单' },
    component: () => import(/* webpackChunkName: "order-receive-h5" */ '@/views/plugin/order-receive/h5/H5Orders')
  },
  {
    path: '/h5/orders/:headId',
    name: 'H5OrderDetail',
    hidden: true,
    meta: { title: 'H5订单详情' },
    component: () => import(/* webpackChunkName: "order-receive-h5" */ '@/views/plugin/order-receive/h5/H5OrderDetail')
  },
  {
    path: '/h5/scan',
    name: 'H5Scan',
    hidden: true,
    meta: { title: 'H5扫码入库' },
    component: () => import(/* webpackChunkName: "order-receive-h5" */ '@/views/plugin/order-receive/h5/H5Scan')
  },
  // 收单插件 H5 配送员任务（免登录，任务 secure_token 即凭证，见 permission.js 白名单 /h5）
  {
    path: '/h5/delivery/:token',
    name: 'H5Delivery',
    hidden: true,
    meta: { title: 'H5配送任务' },
    component: () => import(/* webpackChunkName: "order-receive-h5" */ '@/views/plugin/order-receive/h5/H5Delivery')
  },
  // 打印模板路由 - 用于从单据详情跳转到模板设计器
  {
    path: '/print-template',
    component: TabLayout,
    hidden: true,
    children: [
      {
        path: 'list',
        name: 'TemplateList',
        meta: { title: '模板列表' },
        component: () => import(/* webpackChunkName: "print-template" */ '@/views/plugin/print-template/TemplateList')
      },
      {
        path: 'designer',
        name: 'TemplateDesigner',
        meta: { title: '模板设计' },
        component: () => import(/* webpackChunkName: "print-template" */ '@/views/plugin/print-template/TemplateDesigner')
      },
      {
        path: 'designer-v2',
        name: 'TemplateDesignerV2',
        meta: { title: '模板设计(新版)' },
        component: () => import(/* webpackChunkName: "print-template" */ '@/views/plugin/print-template/TemplateDesignerV2')
      }
    ]
  },
  // hiprint 测试路由 - 临时测试用
  {
    path: '/test',
    component: TabLayout,
    hidden: true,
    children: [
      {
        path: 'hiprint',
        name: 'HiprintTest',
        meta: { title: 'hiprint测试' },
        component: () => import(/* webpackChunkName: "test" */ '@/views/test/HiprintTest')
      }
    ]
  },

]
